import { BASIC_INFO_LOAD, BASIC_INFO_LOAD_SUCCESS, BASIC_INFO_LOAD_FAIL } from '../actions/driverTypes.js';
import { WORKING_AREA_LOAD, WORKING_AREA_LOAD_SUCCESS, WORKING_AREA_LOAD_FAIL } from '../actions/driverTypes.js';
import { DRIVER_LIST_LOAD, DRIVER_LIST_LOAD_SUCCESS, DRIVER_LIST_LOAD_FAIL } from '../actions/driverTypes.js';
import { DRIVER_INFO_LOAD, DRIVER_INFO_LOAD_SUCCESS, DRIVER_INFO_LOAD_FAIL } from '../actions/driverTypes.js';
import { DRIVER_INFO_ADD, DRIVER_INFO_ADD_SUCCESS,  DRIVER_INFO_ADD_FAIL } from '../actions/driverTypes.js';
import { DRIVER_INFO_UPDATE, DRIVER_INFO_UPDATE_SUCCESS,  DRIVER_INFO_UPDATE_FAIL } from '../actions/driverTypes.js';
import { HANDLE_ADD_EDIT_DRIVER_DIALOG } from '../actions/driverTypes.js';
import { GET_TEAM_LIST, GET_TEAM_LIST_SUCCESS, GET_TEAM_LIST_FAIL } from '../actions/driverTypes.js';
import { ADD_NEW_DRIVER_TEAM, ADD_NEW_DRIVER_TEAM_SUCCESS, ADD_NEW_DRIVER_TEAM_FAIL } from '../actions/driverTypes.js';
import { HANDLE_DRIVER_ID } from '../actions/driverTypes.js';
import { GET_NEW_STORAGE_INFO, GET_NEW_STORAGE_INFO_SUCCESS, GET_NEW_STORAGE_INFO_FAIL } from '../actions/driverTypes';
import { LOG_DRIVER_OPERATIONS, LOG_DRIVER_OPERATIONS_SUCCESS, LOG_DRIVER_OPERATIONS_FAIL } from '../actions/driverTypes';

import _ from 'lodash';

const initialState = {
    driverId: '',
    basicInfoError: false,
    cityList: [],
    districtList: [],
    workingAreaList: [],
    teamList: [],
    groupList: [],    
    salaryTypeList: [],
    salaryTypeFixList: [],
    DEFAULT_SALARY_TYPE: "FIX",
    DEFAULT_SALARY_TYPE_FIX: "FIX_2.2",
    // fromPage: 1,
    // lastPage: 1,
    // pageSize: 10,
    pageTotal: 0,
    
    area: 1,
    isLoading: false,
    isError: false,
    //get the driver list
    driverList: [],
    isDriverListLoading: false,
    isDriverListError: false,
    //
    //isOpenModal: false,
    //get the detail driver info
    driverInfo: [],
    driverInfoLoading: false,
    driverInfoError: false,

    openAddEditDriverDialog: false,

    // for driver info update
    // shoud recall data from the database if it's changed
    driverAddStatus: "",   
    driverAddRetMsg: "",
    driverAddError: false,

    // for driver info update
    // shoud recall data from the database if it's changed
    driverUpdateStatus: "",  
    driverUpdateRetMsg: "",
    driverUpdatError: false,

    getNewStorageInfo: [],
    getNewStorageInfoLoading: false,
    getNewStorageInfoError: false,

    searchTypeList: [
        { label: 'driver_id', value: "driver_id" },
        { label: 'phone', value: "phone" },
    ],

    logDriverOperationsLoading: false,
    logDriverOperations: [],
    logDriverOperationsError: false
}

export default function driverReducer(state = initialState, action) {
    switch(action.type) {
        case LOG_DRIVER_OPERATIONS:
            return {
                ...state,
                logDriverOperationsLoading: true
            }
        case LOG_DRIVER_OPERATIONS_SUCCESS:
            return {
                ...state,
                logDriverOperations: action.payload, 
                logDriverOperationsLoading: false      
            }
        case LOG_DRIVER_OPERATIONS_FAIL:
            return {
                ...state,
                logDriverOperations: initialState.logDriverOperations,
                logDriverOperationsLoading: false,
                logDriverOperationsError: action.payload
            }
        case HANDLE_DRIVER_ID:
            return {
                ...state,
                driverId: action.payload
            }
        case BASIC_INFO_LOAD:
            return {
                ...state,
                basicInfoError: false,            
            }
        case BASIC_INFO_LOAD_SUCCESS:
            return {
                ...state,
                groupList: action.payload.data.driver_group,  
                salaryTypeList: action.payload.data.salay_type, 
                cityList:  action.payload.data.city, 
                //districtList: action.payload.data.city.district, 
                basicInfoError: false,
            }
        case BASIC_INFO_LOAD_FAIL:
            return {
                ...state,
                basicInfoError: true,
            }    
        case WORKING_AREA_LOAD:
            return {
                ...state,
                workingAreaError: false,            
            }
        case WORKING_AREA_LOAD_SUCCESS:
            return {
                ...state,
                workingAreaList: action.payload.data, 
                workingAreaError: false,
            }
        case WORKING_AREA_LOAD_FAIL:
            return {
                ...state,
                workingAreaError: true,
            }    
        case ADD_NEW_DRIVER_TEAM:
            return {
                ...state,
                addNewDriverTeamError: false,            
            }
        case ADD_NEW_DRIVER_TEAM_SUCCESS:
            return {
                ...state,
                addNewDriverTeam: action.payload.data, 
                addNewDriverTeamError: false,
            }
        case ADD_NEW_DRIVER_TEAM_FAIL:
            return {
                ...state,
                addNewDriverTeamError: true,
            }  
        case GET_TEAM_LIST:
            return {
                ...state,
                teamListError: false,            
            }
        case GET_TEAM_LIST_SUCCESS:
            return {
                ...state,
                teamList: action.payload.data, 
                teamListError: false,
            }
        case GET_TEAM_LIST_FAIL:
            return {
                ...state,
                teamListError: true,
            }            
        case DRIVER_LIST_LOAD:
            return {
                ...state,
                driverList:[],
                isDriverListLoading: true,
                isDriverListError: false,            
            }
        case DRIVER_LIST_LOAD_SUCCESS:
            return {
                ...state,
                isDriverListLoading: false,
                driverList: action.payload.data,
                // fromPage: action.payload.from,   
                // lastPage: action.payload.last_page,
                // pageSize: action.payload.per_page,
                pageTotal: action.payload.total,
            }
        case DRIVER_LIST_LOAD_FAIL:
            return {
                ...state,
                isDriverListLoading: false,
                isDriverListError: action.payload,
            }    
        case DRIVER_INFO_LOAD:
            return {
                ...state,
                driverInfoLoading: true,
                driverInfoError: false,            
            }
        case DRIVER_INFO_LOAD_SUCCESS:
            return {
                ...state,
                driverInfoLoading: false,
                driverInfo: action.payload,
            }
        case DRIVER_INFO_LOAD_FAIL:
            return {
                ...state,
                driverInfoLoading: false,
                driverInfoError: action.payload,
            }    
        case HANDLE_ADD_EDIT_DRIVER_DIALOG:
            return {
                ...state,
                openAddEditDriverDialog: action.payload,
            }    
        case DRIVER_INFO_ADD:
            return {
                ...state,
                driverAddStatus: "",   
                driverAddRetMsg: "",
                isDriverAddedError: false
            }
        case DRIVER_INFO_ADD_SUCCESS:
            return {
                ...state,                
                driverAddStatus: action.payload.status,   
                driverAddRetMsg: action.payload.ret_msg,
                driverAddError: false,
            }
        case DRIVER_INFO_ADD_FAIL:
            return {
                ...state,
                driverAddStatus: "FAIL",   
                driverAddRetMsg: action.payload.message,
                driverAddError: true,
            }            
        case DRIVER_INFO_UPDATE:
            return {
                ...state,
                driverUpdateStatus: "",   
                driverUpdateRetMsg: "",
                driverUpdatError: false,
            }
        case DRIVER_INFO_UPDATE_SUCCESS:
            return {
                ...state,
                driverUpdateStatus: action.payload.status,   
                driverUpdateRetMsg: action.payload.ret_msg,
                driverUpdatError: false,
            }
        case DRIVER_INFO_UPDATE_FAIL:
            return {
                ...state,
                driverUpdateStatus: "FAIL",   
                driverUpdateRetMsg: action.payload.message,
                driverUpdatError: true,
            }        
        case GET_NEW_STORAGE_INFO:
            return {
                ...state,
                getNewStorageInfo: action.payload,
                getNewStorageInfoLoading: false
            }
        case GET_NEW_STORAGE_INFO_SUCCESS:
            return {
                ...state,
                getNewStorageInfo: action.payload,
                getNewStorageInfoLoading: false
            }
        case GET_NEW_STORAGE_INFO_FAIL:
            return {
                ...state,
                getNewStorageInfoLoading: false,
                getNewStorageInfoError: action.payload
            }        
        default: 
            return state
    }
}
